var map = {
	"./bigorneaux.webp": 569,
	"./bulots.webp": 663,
	"./cafe_locqui.jpg": 993,
	"./cafe_morlaix.jpg": 390,
	"./casino.png": 959,
	"./coques.webp": 259,
	"./degustation.jpg": 270,
	"./dourduff.webp": 287,
	"./huitres.webp": 95,
	"./huitres_main.jpg": 163,
	"./huitresp.webp": 113,
	"./intermarche.png": 622,
	"./kerdies.jpg": 849,
	"./marche.jpg": 230,
	"./medal.png": 763,
	"./moules.webp": 333,
	"./palourdes.webp": 727,
	"./parcs_a_huitres.jpg": 28,
	"./primelcafe.webp": 86,
	"./radeau.webp": 130,
	"./staticmap.png": 649,
	"./superu.png": 412,
	"./viarmes.webp": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;